<template>
  <MobileDrawer v-if="active" :active="active" @close="handleClose">
    <div class="-my-1">
      <div class="text-center mb-4">        
        <h3 class="text-xl font-semibold mb-2">Install App</h3>
      </div>

      <div v-if="isIOS" class="text-left">
        <p class="mb-3"><strong>To install this app on iOS:</strong></p>
        <ol class="list-decimal list-inside space-y-2 ml-2">
          <li class="flex items-center gap-2">
            Tap the <strong>Share</strong> button
            <Icon icon="square-arrow-up" class="inline-block" />
            at the bottom
          </li>
          <li>Scroll down and tap <strong>"Add to Home Screen"</strong></li>
          <li>Tap <strong>"Add"</strong> in the top right</li>
        </ol>
      </div>

      <div v-else-if="isMacOS" class="text-left">
        <p class="mb-3"><strong>To install this app on macOS:</strong></p>
        <ol class="list-decimal list-inside space-y-2 ml-2">
          <li>Click <strong>File</strong> → <strong>Add to Dock</strong></li>
          <li>Or use the <strong>Share</strong> button in the toolbar</li>
        </ol>
      </div>

      <Button primary block class="mt-6" @click="handleGotIt">
        Got it
      </Button>
    </div>
  </MobileDrawer>
</template>

<script>
import MobileDrawer from '@/components/MobileDrawer.vue';
import Button from '@/components/Button.vue';
import Icon from '@/components/Icon.vue';

export default {
  name: 'InstallPrompt',
  components: {
    MobileDrawer,
    Button,
    Icon,
  },
  computed: {
    active() {
      return this.$store.state.ui.installPromptActive || false;
    },
    isIOS() {
      return /iPad|iPhone|iPod/.test(navigator.userAgent);
    },
    isMacOS() {
      return /Macintosh/.test(navigator.userAgent);
    },
  },
  methods: {
    handleClose() {
      this.$store.dispatch('ui/setInstallPromptActive', false);
    },
    handleGotIt() {
      localStorage.setItem('safariInstallBannerDismissed', '1');
      this.handleClose();
    },
  },
};
</script>
